import React, { memo } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Switcher } from '@shared/ui';

import cls from './Calculations.module.css';
import { Doors } from './Doors/Doors';
import { Square } from './Square/Square';
import { useCalculations } from './useCalculations';
import { Windows } from './Windows/Windows';
import { RowTitle } from '../../../../../Measurements/MeasurementsModal/MeasurementsModalBody/RowTitle';

export const Calculations = memo(() => {
    const { isManualCalculations, onSwitcher, onInput, calculations, manualCalculations } =
        useCalculations();
    const { t } = useTranslation();
    return (
        <>
            <div className={cls.headerWrapper}>
                <div className={cls.header}>
                    <RowTitle
                        title={t('Calculations.return.switcherTitle')}
                        type="calculations"
                    />
                    <Switcher isActive={isManualCalculations} onClick={onSwitcher} />
                </div>
                <span className={cls.details}>{t('Calculations.return.span.details')}</span>
            </div>
            <div className={classNames(cls.Calculations)}>
                <Square
                    isManualCalculations={isManualCalculations}
                    onInput={onInput}
                    calculations={calculations}
                    manualCalculations={manualCalculations}
                />
                <Doors
                    isManualCalculations={isManualCalculations}
                    onInput={onInput}
                    calculations={calculations}
                    manualCalculations={manualCalculations}
                />
                <Windows
                    isManualCalculations={isManualCalculations}
                    onInput={onInput}
                    calculations={calculations}
                    manualCalculations={manualCalculations}
                />
            </div>
        </>
    );
});
